// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js","713":"component---src-templates-tour-template-js"}[chunkId] + "-" + {"223":"ce4b20de1451aa21519a","293":"6c042368ede05698dbb4","713":"0cd186d4d85d10f33360"}[chunkId] + ".js";
};